import script from "./MessaggioModale.vue?vue&type=script&setup=true&lang=js"
export * from "./MessaggioModale.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__